import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { currentUserIsInAdminRole } from "reduxSlices/sessionSlice"
import {
  loadUnassignedTasks,
  unassignedTasksLoaded as unassignedTasksLoadedSelector,
} from "reduxSlices/taskTableSlice"
import { TertiaryButton } from "shared/buttons"

const LoadUnassignedTasks = () => {
  const dispatch = useDispatch()

  const [disabled, setDisabled] = useState(false)
  const disableButton = () => setDisabled(true)

  const unassignedTasksLoaded = useSelector(unassignedTasksLoadedSelector)
  const userIsAdmin = useSelector(currentUserIsInAdminRole)

  if (!userIsAdmin || unassignedTasksLoaded) return null

  const load = () => {
    disableButton()
    dispatch(loadUnassignedTasks())
  }

  return (
    <TertiaryButton disabled={disabled} onClick={load} text="Load Unassigned Tasks" />
  )
}

export default LoadUnassignedTasks
